module.exports = __webpack_public_path__ + "static/media/reading-list-back.e80dd50b.png";